module.exports = __webpack_public_path__ + "img/finland.bab6ae26.svg";